import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=50dbf9d4&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=50dbf9d4&prod&lang=stylus&scoped=true"
import style1 from "./Mobile.vue?vue&type=style&index=1&id=50dbf9d4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.95.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dbf9d4",
  null
  
)

export default component.exports